import { atom } from "jotai";

export interface IHeaderV2ProgressStore {
  progressBar?: boolean;
  progressBarPercentage?: number;
}

export const headerV2ProgressStoreInitialState: IHeaderV2ProgressStore = {
  progressBar: false,
  progressBarPercentage: 0,
};

export const HeaderV2ProgressStore = atom(headerV2ProgressStoreInitialState);
